import { defineMessages } from 'react-intl';

export const composerFileDropOverlayMessages = defineMessages({
  dropTitle: {
    defaultMessage: 'Drop to attach',
    id: 'Ll7DOH/Bma',
    description: 'Title on the composer file drop overlay',
  },
  dropHint: {
    defaultMessage: 'Images, documents, spreadsheets, XML, and more',
    id: 'ajFyTzJr+S',
    description: 'Supported file types hint on the composer drop overlay',
  },
});
